export default {
  CANCELED: 'CANCELED',
  COLLECTED: 'COLLECTED',
  DELIVERED: 'DELIVERED',
  NOT_DELIVERED: 'NOT_DELIVERED',
  PROCESSING: 'PROCESSING',
  RECEIVE_PENDING: 'RECEIVE_PENDING',
  RECEIVE_PENDING_TO_COLLECT: 'RECEIVE_PENDING_TO_COLLECT',
  RECEIVED: 'RECEIVED',
  TO_COLLECT: 'TO_COLLECT'
};
